import getStore from '../store/store';
import { logUsage } from 'owa-analytics';
import { updateUserConfiguration } from 'owa-options-core';
import {
    isDefaultFolderScopeOptionDirty,
    isSearchDeletedItemOptionDirty,
} from '../selectors/isSearchResultsOptionDirty';
import { getUserConfiguration } from 'owa-session-store';
import { setBit, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import {
    setBit as setSearchBit,
    SearchBitFlagsMasks,
} from 'owa-bit-flags/lib/utils/searchBitFlagsUtil';

export default async function saveSearchResultsOptions() {
    if (isDefaultFolderScopeOptionDirty()) {
        saveDefaulScopeOption();
    }

    if (isSearchDeletedItemOptionDirty()) {
        saveSearchDeletedItem();
    }
}

async function saveDefaulScopeOption() {
    const viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;
    setSearchBit(getStore().scopeToInboxFolder, SearchBitFlagsMasks.ScopeInboxSearchToFolder);

    await updateUserConfiguration(
        [
            {
                propertyName: 'SearchBitFlags',
                propertyType: 'Integer32',
                propertyValue: `${viewStateConfiguration?.SearchBitFlags}`,
            },
        ],
        'OWA.ViewStateConfiguration'
    );

    logUsage('TnS_SaveDefaultSearchScopeOption', [getStore().scopeToInboxFolder]);
}

async function saveSearchDeletedItem() {
    const viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;
    setBit(
        getStore().excludeDeletedItemsInSearch,
        ListViewBitFlagsMasks.ExcludeDeletedItemsInSearch
    );

    await updateUserConfiguration(
        [
            {
                propertyName: 'ListViewBitFlags',
                propertyType: 'Integer32',
                propertyValue: `${viewStateConfiguration?.ListViewBitFlags}`,
            },
        ],
        'OWA.ViewStateConfiguration'
    );

    logUsage('TnS_SaveSearchDeletedItemOption', [getStore().excludeDeletedItemsInSearch]);
}
